export const HOME = "/";
export const BETA = "/beta";
export const NEW = "/new";
export const DETAILER = "/detailer";
export const DETAILER_PITCH = "/detailer/hb";
export const DETAILER_SIGNUP = "/detailer/hb/signup";
export const DETAILER_COMPETITION = "/detailer/hb/competition";
export const DETAILER_PACKAGES = "/detailer/hb/packages";
export const PROMO_HB = "/offers/HBNOV19";

export const STRIPE_CONNECT_ONBOARD_FINISH =
  "/dashboard/stripe-connect-onboard-finish";

export const ABOUT = "/about";
export const CONTACT = "/contact";
export const TERMS_OF_USE = "/terms-of-use";
export const PRIVACY_POLICY = "/privacy-policy";

export const STRIPE_WEBSITE = "https://stripe.com/";
export const STRIPE_WEBSITE_ABOUT = "https://stripe.com/about/";



// WEBPACK FOOTER //
// ./src/constants/routes.js